import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { BrandTokens } from "../../../@tokens/BrandTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";


export const style: any = {
    theme: {

        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

        list: {
            height: '64px',
            backgroundColor: BrandTokens.NeutralColorHighPure,
            borderBottom: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorHighMedium} `,
            padding: `0 ${GlobalTokens.SpacingSizeXxs}`,
            // tablet: {
            //   borderRadius: GlobalTokens.BorderRadiusMd,
            // }
          },
    
          label: {
            single:{
              fontFamily: BrandTokens.FontFamily,
              fontSize: GlobalTokens.FontSizeXxs,
              fontWeight: BrandTokens.FontWeightMedium,
              lineHeight: GlobalTokens.LineHeightDefault,
              color: BrandTokens.NeutralColorLowDark,
              textAlign: 'left',
    
    
              // Responsive
              tablet: {
                fontSize: GlobalTokens.FontSizeXs,
              }
            },
            double: {
              fontFamily: BrandTokens.FontFamily,
              fontSize: GlobalTokens.FontSizeXs,
              fontWeight: BrandTokens.FontWeightMedium,
              lineHeight: GlobalTokens.LineHeightDefault,
              color: BrandTokens.NeutralColorLowDark,
              textAlign: 'left',
              paddingBottom: GlobalTokens.SpacingSizeQuarck
            },
          },
    
          text: {
            fontFamily: BrandTokens.FontFamily,
            fontSize: GlobalTokens.FontSizeXxs,
            fontWeight: BrandTokens.FontWeightRegular,
            lineHeight: GlobalTokens.LineHeightDefault,
            color: BrandTokens.NeutralColorLowMedium,
            textAlign: 'left',
          },
    
          leadingIcon: {
            paddingRight: GlobalTokens.SpacingSizeXxxs
          },
    
          trailingIcon: {
            paddingLeft: GlobalTokens.SpacingSizeXxxs
          },
    
          states: {
            hover: {
              list: {
                backgroundColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelMedium),
                color: BrandTokens.BrandColorPrimaryDark
              }
            },
            focus: {
              list: {
                outline: `${GlobalTokens.BorderWidthThin} solid ${BrandTokens.HighlightColorPure}`,
                outlineOffset: GlobalTokens.BorderWidthThin
              }
            },
          }
    }
}